/*
 * Copyright (c) 2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export const DEFAULT_RENDER_FUNCTION = (value: any) => value

// Helper functions.
export function getColumnValue(obj: Record<string, any>, key: string): any {
  const keys = key.split('.')
  let val = obj

  for (const key of keys) {
    if (val[key] === undefined) continue
    val = val[key]
  }

  return val
}
